import React from 'react';
import { connect } from 'react-redux';
import agent from '../../agent';
import { Link } from 'react-router-dom';

function mapDispatchToProps(dispatch) {
  return {
    onLoad: artistid => {
      agent.Artists.get(dispatch, artistid);
      agent.Mediums.all(dispatch);
    },
    onUnload: () =>
      dispatch({ type: 'ARTIST_PAGE_UNLOADED' })
  }
}

const mapStateToProps = state => ({
  ...state.artists,
  ...state.mediums
});

const styles = {
  info: {
    color: '#000',
    fontSize: '14px',
    textDecoration: 'none',
    fontWeight: '300'
  },
  back: {
    color: '#000',
    textDecoration: 'none'
  }
}

class Artist extends React.Component {
  componentWillMount() {
    this.props.onLoad(this.props.match.params.artistid);
  }

  componentWillUnmount() {
    this.props.onUnload();
  }

  getImageList(images) {

  }

  mapMediums(mediums) {
    let mediumsStr = "";
    mediums.map(medium => mediumsStr += this.props.mediums[medium] + ", ");
    return mediumsStr.replace(/,\s*$/, "");
  }

  onBackClick(event) {
    event.preventDefault();

    window.history.back();
  }

  render() {
    if(!this.props.artist || !this.props.mediums) {
      return null;
    }

    let images = null;
    if(this.props.artist.images) {
      images = this.props.artist.images.map( image => <img key={image.original} src={"http://storage.googleapis.com/art-trove.appspot.com/" + image.original} alt={this.props.artist.name} style={{maxWidth: "100%", maxHeight: "100vh", display: "inline-block", margin: "12px"}} />)
    }

    let location = this.props.artist.location ? <p style={styles.info}>{this.props.artist.location}</p> : null;
    let agency = this.props.artist.agency ? <p style={styles.info}>{this.props.artist.agency}</p> : null;
    let instagram = this.props.artist.instagram ? <p style={styles.info}><a style={{color: '#000'}} href={this.props.artist.instagram} target="_blank">Instagram</a></p> : null;
    let website = this.props.artist.website ? <p style={styles.info}><a style={{color: '#000'}} href={this.props.artist.website} target="_blank">Website</a></p> : null;

    return (
      <div>
        <div style={{display: 'flex'}}>
          <div style={{fontWeight: '300', padding: '2%', width: "20vw", position:"fixed", wordBreak: 'break-all'}}>
            <p style={{marginTop: 0, fontSize: '18px', fontWeight:"400"}}>{this.props.artist.name}</p>
            <p style={styles.info}>{this.props.artist.mediums &&

              this.mapMediums(this.props.artist.mediums)
            }</p>
            {location}
            {agency}
            {instagram}
            {website}
            <p style={{marginTop:"50px"}}><Link style={styles.back} to="" onClick={this.onBackClick}>&larr; Back</Link></p>
          </div>
          <div className="col-md-6" style={{marginLeft:"20vw", width:"60vw", textAlign:"center"}}>
            {images}
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Artist);



// WEBPACK FOOTER //
// ./src/components/Artist/index.js